// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colorful Theme for UAR Application */

/* Page Containers */
.container-fluid {
  background-color: #f8f9fc !important;
  min-height: 100vh;
}

/* Cards - Colorful Headers */
.card {
  border-radius: 15px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06) !important;
  overflow: hidden;
}

.card-header {
  border-bottom: 2px solid #e2e8f0 !important;
  padding: 20px 24px !important;
  font-weight: 700 !important;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%) !important;
}

/* Gradient Card Headers - Apply different colors to different pages */
.card-header:not([style*="background"]) {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%) !important;
  color: #2d3748 !important;
}

.card-header h5,
.card-header h6,
.card-header .h5,
.card-header .h6 {
  color: #2d3748 !important;
  font-weight: 700 !important;
}

/* Buttons */
.btn-primary {
  background: #3182ce !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(49, 130, 206, 0.25) !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
  color: #ffffff !important;
}

.btn-primary:hover {
  background: #2c5282 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(49, 130, 206, 0.35) !important;
}

.btn-success {
  background: #48bb78 !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(72, 187, 120, 0.25) !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.btn-success:hover {
  background: #38a169 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.35) !important;
}

.btn-info {
  background: #4299e1 !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(66, 153, 225, 0.25) !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.btn-info:hover {
  background: #3182ce !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.35) !important;
}

.btn-warning {
  background: #ed8936 !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(237, 137, 54, 0.25) !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.btn-warning:hover {
  background: #dd6b20 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(237, 137, 54, 0.35) !important;
}

.btn-danger {
  background: #f56565 !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(245, 101, 101, 0.25) !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.btn-danger:hover {
  background: #e53e3e !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.35) !important;
}

.btn-secondary {
  background: #718096 !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(113, 128, 150, 0.25) !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.btn-secondary:hover {
  background: #4a5568 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(113, 128, 150, 0.35) !important;
}

/* Outline Buttons */
.btn-outline-primary {
  border: 2px solid #3182ce !important;
  color: #3182ce !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background: transparent !important;
}

.btn-outline-primary:hover {
  background: #3182ce !important;
  color: #fff !important;
  border-color: #3182ce !important;
}

.btn-outline-success {
  border: 2px solid #48bb78 !important;
  color: #48bb78 !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background: transparent !important;
}

.btn-outline-success:hover {
  background: #48bb78 !important;
  color: #fff !important;
  border-color: #48bb78 !important;
}

.btn-outline-danger {
  border: 2px solid #f56565 !important;
  color: #f56565 !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background: transparent !important;
}

.btn-outline-danger:hover {
  background: #f56565 !important;
  color: #fff !important;
  border-color: #f56565 !important;
}

.btn-outline-warning {
  border: 2px solid #ed8936 !important;
  color: #ed8936 !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background: transparent !important;
}

.btn-outline-warning:hover {
  background: #ed8936 !important;
  color: #fff !important;
  border-color: #ed8936 !important;
}

/* Badges */
.badge {
  padding: 6px 16px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
}

.badge.bg-primary {
  background: #3182ce !important;
  color: #ffffff !important;
}

.badge.bg-success {
  background: #48bb78 !important;
  color: #ffffff !important;
}

.badge.bg-info {
  background: #4299e1 !important;
  color: #ffffff !important;
}

.badge.bg-warning {
  background: #ed8936 !important;
  color: #ffffff !important;
}

.badge.bg-danger {
  background: #f56565 !important;
  color: #ffffff !important;
}

.badge.bg-secondary {
  background: #718096 !important;
  color: #ffffff !important;
}

/* Tables */
.table {
  border-radius: 10px !important;
  overflow: hidden;
}

.table thead {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
}

.table thead th {
  font-weight: 700 !important;
  color: #ffffff !important;
  border-bottom: none !important;
  padding: 14px 16px !important;
  vertical-align: middle !important;
  text-align: left !important;
  letter-spacing: 0.3px !important;
}

.table tbody tr {
  transition: all 0.3s ease;
}

.table tbody td {
  color: #2c3e50 !important;
  padding: 12px 16px !important;
  vertical-align: middle !important;
  text-align: left !important;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fc !important;
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.table-dark {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.table-dark th {
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  vertical-align: middle !important;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(102, 126, 234, 0.05) !important;
}

/* Ensure consistent alignment across all table elements */
.table th,
.table td {
  vertical-align: middle !important;
}

/* Fix for responsive tables */
.table-responsive .table thead th {
  white-space: nowrap;
  vertical-align: middle !important;
}

.table-responsive .table tbody td {
  vertical-align: middle !important;
}

/* Modals */
.modal-content {
  border-radius: 15px !important;
  border: none !important;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
  color: #fff !important;
  border-bottom: none !important;
  padding: 20px 24px !important;
}

.modal-header .modal-title {
  font-weight: 700 !important;
  color: #fff !important;
}

.modal-header .btn-close {
  filter: brightness(0) invert(1);
}

/* Form Controls */
.form-control,
.form-select {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  padding: 10px 16px !important;
  transition: all 0.3s ease !important;
}

.form-control:focus,
.form-select:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25) !important;
}

/* Alerts */
.alert {
  border-radius: 10px !important;
  border: none !important;
  padding: 16px 20px !important;
  font-weight: 500 !important;
}

.alert-success {
  background: #d4edda !important;
  color: #155724 !important;
  border: 1px solid #c3e6cb !important;
}

.alert-info {
  background: #d1ecf1 !important;
  color: #0c5460 !important;
  border: 1px solid #bee5eb !important;
}

.alert-warning {
  background: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
}

.alert-danger {
  background: #f8d7da !important;
  color: #721c24 !important;
  border: 1px solid #f5c6cb !important;
}

.alert-primary {
  background: #d6e9f8 !important;
  color: #004085 !important;
  border: 1px solid #b8daff !important;
}

/* Progress Bars */
.progress {
  border-radius: 10px !important;
  height: 12px !important;
  background-color: #e9ecef !important;
}

.progress-bar {
  background: #3182ce !important;
  border-radius: 10px !important;
}

/* Pagination */
.pagination .page-link {
  border-radius: 8px !important;
  margin: 0 4px !important;
  border: 1px solid #e9ecef !important;
  color: #3182ce !important;
  font-weight: 600 !important;
}

.pagination .page-link:hover {
  background: #3182ce !important;
  color: #fff !important;
  border-color: #3182ce !important;
}

.pagination .page-item.active .page-link {
  background: #3182ce !important;
  border-color: #3182ce !important;
  color: #fff !important;
}

/* Spinner */
.spinner-border {
  border-color: #3182ce !important;
  border-right-color: transparent !important;
}

/* List Groups */
.list-group-item {
  border-radius: 10px !important;
  margin-bottom: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.list-group-item:hover {
  background-color: #f8f9fc !important;
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* Page Headers */
h1, h2, h3, h4, h5, h6 {
  color: #2c3e50 !important;
  font-weight: 700 !important;
}

/* Override any dark/black table headers */
.table thead.table-dark th,
.table thead[class*="dark"] th,
.table thead[style*="background"] th {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
  color: #ffffff !important;
}

/* Ensure card header text is always visible */
.card-header h1,
.card-header h2,
.card-header h3,
.card-header h4,
.card-header h5,
.card-header h6 {
  color: #2d3748 !important;
}

/* Fix for any remaining dark backgrounds on headers */
thead[style*="background: #"] {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
}

thead[style*="background:#"] {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
}

/* Shadow Effects */
.shadow-sm {
  box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
}

.shadow {
  box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
}

.shadow-lg {
  box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
}

/* §K63: the cascade note inside an .alert must be bold; the theme's
   .alert{font-weight:500!important} otherwise wins over an inline weight. */
.cascade-note-text {
  font-weight: 700 !important;
}
`, "",{"version":3,"sources":["webpack://./src/colorful-theme.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,oBAAoB;AACpB;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA,sEAAsE;AACtE;EACE,wEAAwE;EACxE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAyD;EACzD,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAyD;EACzD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAyD;EACzD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAyD;EACzD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,0DAA0D;EAC1D,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,0DAA0D;EAC1D,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,sDAAsD;AACxD;;AAEA,0DAA0D;AAC1D;;EAEE,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;EAEE,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;;;EAGE,wEAAwE;EACxE,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;;;;;;EAME,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,mBAAmB;AACnB;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;4EAC4E;AAC5E;EACE,2BAA2B;AAC7B","sourcesContent":["/* Colorful Theme for UAR Application */\n\n/* Page Containers */\n.container-fluid {\n  background-color: #f8f9fc !important;\n  min-height: 100vh;\n}\n\n/* Cards - Colorful Headers */\n.card {\n  border-radius: 15px !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.06) !important;\n  overflow: hidden;\n}\n\n.card-header {\n  border-bottom: 2px solid #e2e8f0 !important;\n  padding: 20px 24px !important;\n  font-weight: 700 !important;\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%) !important;\n}\n\n/* Gradient Card Headers - Apply different colors to different pages */\n.card-header:not([style*=\"background\"]) {\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%) !important;\n  color: #2d3748 !important;\n}\n\n.card-header h5,\n.card-header h6,\n.card-header .h5,\n.card-header .h6 {\n  color: #2d3748 !important;\n  font-weight: 700 !important;\n}\n\n/* Buttons */\n.btn-primary {\n  background: #3182ce !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(49, 130, 206, 0.25) !important;\n  font-weight: 600 !important;\n  transition: all 0.2s ease !important;\n  color: #ffffff !important;\n}\n\n.btn-primary:hover {\n  background: #2c5282 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(49, 130, 206, 0.35) !important;\n}\n\n.btn-success {\n  background: #48bb78 !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(72, 187, 120, 0.25) !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.btn-success:hover {\n  background: #38a169 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.35) !important;\n}\n\n.btn-info {\n  background: #4299e1 !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(66, 153, 225, 0.25) !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.btn-info:hover {\n  background: #3182ce !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.35) !important;\n}\n\n.btn-warning {\n  background: #ed8936 !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(237, 137, 54, 0.25) !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.btn-warning:hover {\n  background: #dd6b20 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(237, 137, 54, 0.35) !important;\n}\n\n.btn-danger {\n  background: #f56565 !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(245, 101, 101, 0.25) !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.btn-danger:hover {\n  background: #e53e3e !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.35) !important;\n}\n\n.btn-secondary {\n  background: #718096 !important;\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(113, 128, 150, 0.25) !important;\n  font-weight: 600 !important;\n  color: #ffffff !important;\n}\n\n.btn-secondary:hover {\n  background: #4a5568 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(113, 128, 150, 0.35) !important;\n}\n\n/* Outline Buttons */\n.btn-outline-primary {\n  border: 2px solid #3182ce !important;\n  color: #3182ce !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  background: transparent !important;\n}\n\n.btn-outline-primary:hover {\n  background: #3182ce !important;\n  color: #fff !important;\n  border-color: #3182ce !important;\n}\n\n.btn-outline-success {\n  border: 2px solid #48bb78 !important;\n  color: #48bb78 !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  background: transparent !important;\n}\n\n.btn-outline-success:hover {\n  background: #48bb78 !important;\n  color: #fff !important;\n  border-color: #48bb78 !important;\n}\n\n.btn-outline-danger {\n  border: 2px solid #f56565 !important;\n  color: #f56565 !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  background: transparent !important;\n}\n\n.btn-outline-danger:hover {\n  background: #f56565 !important;\n  color: #fff !important;\n  border-color: #f56565 !important;\n}\n\n.btn-outline-warning {\n  border: 2px solid #ed8936 !important;\n  color: #ed8936 !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  background: transparent !important;\n}\n\n.btn-outline-warning:hover {\n  background: #ed8936 !important;\n  color: #fff !important;\n  border-color: #ed8936 !important;\n}\n\n/* Badges */\n.badge {\n  padding: 6px 16px !important;\n  border-radius: 6px !important;\n  font-weight: 600 !important;\n  font-size: 0.85rem !important;\n}\n\n.badge.bg-primary {\n  background: #3182ce !important;\n  color: #ffffff !important;\n}\n\n.badge.bg-success {\n  background: #48bb78 !important;\n  color: #ffffff !important;\n}\n\n.badge.bg-info {\n  background: #4299e1 !important;\n  color: #ffffff !important;\n}\n\n.badge.bg-warning {\n  background: #ed8936 !important;\n  color: #ffffff !important;\n}\n\n.badge.bg-danger {\n  background: #f56565 !important;\n  color: #ffffff !important;\n}\n\n.badge.bg-secondary {\n  background: #718096 !important;\n  color: #ffffff !important;\n}\n\n/* Tables */\n.table {\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n}\n\n.table thead th {\n  font-weight: 700 !important;\n  color: #ffffff !important;\n  border-bottom: none !important;\n  padding: 14px 16px !important;\n  vertical-align: middle !important;\n  text-align: left !important;\n  letter-spacing: 0.3px !important;\n}\n\n.table tbody tr {\n  transition: all 0.3s ease;\n}\n\n.table tbody td {\n  color: #2c3e50 !important;\n  padding: 12px 16px !important;\n  vertical-align: middle !important;\n  text-align: left !important;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f8f9fc !important;\n  transform: scale(1.01);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.table-dark {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.table-dark th {\n  color: #fff !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n  vertical-align: middle !important;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(102, 126, 234, 0.05) !important;\n}\n\n/* Ensure consistent alignment across all table elements */\n.table th,\n.table td {\n  vertical-align: middle !important;\n}\n\n/* Fix for responsive tables */\n.table-responsive .table thead th {\n  white-space: nowrap;\n  vertical-align: middle !important;\n}\n\n.table-responsive .table tbody td {\n  vertical-align: middle !important;\n}\n\n/* Modals */\n.modal-content {\n  border-radius: 15px !important;\n  border: none !important;\n  overflow: hidden;\n}\n\n.modal-header {\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n  color: #fff !important;\n  border-bottom: none !important;\n  padding: 20px 24px !important;\n}\n\n.modal-header .modal-title {\n  font-weight: 700 !important;\n  color: #fff !important;\n}\n\n.modal-header .btn-close {\n  filter: brightness(0) invert(1);\n}\n\n/* Form Controls */\n.form-control,\n.form-select {\n  border-radius: 8px !important;\n  border: 1px solid #e9ecef !important;\n  padding: 10px 16px !important;\n  transition: all 0.3s ease !important;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #667eea !important;\n  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25) !important;\n}\n\n/* Alerts */\n.alert {\n  border-radius: 10px !important;\n  border: none !important;\n  padding: 16px 20px !important;\n  font-weight: 500 !important;\n}\n\n.alert-success {\n  background: #d4edda !important;\n  color: #155724 !important;\n  border: 1px solid #c3e6cb !important;\n}\n\n.alert-info {\n  background: #d1ecf1 !important;\n  color: #0c5460 !important;\n  border: 1px solid #bee5eb !important;\n}\n\n.alert-warning {\n  background: #fff3cd !important;\n  color: #856404 !important;\n  border: 1px solid #ffeeba !important;\n}\n\n.alert-danger {\n  background: #f8d7da !important;\n  color: #721c24 !important;\n  border: 1px solid #f5c6cb !important;\n}\n\n.alert-primary {\n  background: #d6e9f8 !important;\n  color: #004085 !important;\n  border: 1px solid #b8daff !important;\n}\n\n/* Progress Bars */\n.progress {\n  border-radius: 10px !important;\n  height: 12px !important;\n  background-color: #e9ecef !important;\n}\n\n.progress-bar {\n  background: #3182ce !important;\n  border-radius: 10px !important;\n}\n\n/* Pagination */\n.pagination .page-link {\n  border-radius: 8px !important;\n  margin: 0 4px !important;\n  border: 1px solid #e9ecef !important;\n  color: #3182ce !important;\n  font-weight: 600 !important;\n}\n\n.pagination .page-link:hover {\n  background: #3182ce !important;\n  color: #fff !important;\n  border-color: #3182ce !important;\n}\n\n.pagination .page-item.active .page-link {\n  background: #3182ce !important;\n  border-color: #3182ce !important;\n  color: #fff !important;\n}\n\n/* Spinner */\n.spinner-border {\n  border-color: #3182ce !important;\n  border-right-color: transparent !important;\n}\n\n/* List Groups */\n.list-group-item {\n  border-radius: 10px !important;\n  margin-bottom: 8px !important;\n  border: 1px solid #e9ecef !important;\n  transition: all 0.3s ease !important;\n}\n\n.list-group-item:hover {\n  background-color: #f8f9fc !important;\n  transform: translateX(5px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n/* Page Headers */\nh1, h2, h3, h4, h5, h6 {\n  color: #2c3e50 !important;\n  font-weight: 700 !important;\n}\n\n/* Override any dark/black table headers */\n.table thead.table-dark th,\n.table thead[class*=\"dark\"] th,\n.table thead[style*=\"background\"] th {\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n  color: #ffffff !important;\n}\n\n/* Ensure card header text is always visible */\n.card-header h1,\n.card-header h2,\n.card-header h3,\n.card-header h4,\n.card-header h5,\n.card-header h6 {\n  color: #2d3748 !important;\n}\n\n/* Fix for any remaining dark backgrounds on headers */\nthead[style*=\"background: #\"] {\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n}\n\nthead[style*=\"background:#\"] {\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n}\n\n/* Shadow Effects */\n.shadow-sm {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;\n}\n\n.shadow {\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;\n}\n\n/* §K63: the cascade note inside an .alert must be bold; the theme's\n   .alert{font-weight:500!important} otherwise wins over an inline weight. */\n.cascade-note-text {\n  font-weight: 700 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
